import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLoading = isLoading => ({
  type: actionTypes.SET_VEHICLE_PARTS_FILTERED_FIELDS_LOADING,
  payload: isLoading
})
